import React, { useEffect, useMemo } from "react";
import classes from "./drawing-item.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentDrawingRectangle } from "../../../../reducers/editor/actions";
import { selectCanvas } from "../../../../reducers/pdf-viewer/selectors";
import {selectCurrentPointerMode, selectSettingColors} from "../../../../reducers/editor/selectors";

const DrawingItem = ({
  isMouseDown,
  position,
  mouseDownPositionX,
  mouseDownPositionY,
  convertXToPdfUnits,
  convertYToPdfUnits,
  pageRef,
}) => {
  const canvas = useSelector(selectCanvas);
  const settingColors = useSelector(selectSettingColors);

  const dispatch = useDispatch();

  const topLeftCornerX = useMemo(() => {
    return Math.min(position.x, mouseDownPositionX);
  }, [position.x, mouseDownPositionX]);
  const topLeftCornerY = useMemo(() => {
    return Math.min(position.y, mouseDownPositionY);
  }, [position.y, mouseDownPositionY]);
  const bottomRightCornerX = useMemo(() => {
    return Math.max(position.x, mouseDownPositionX);
  }, [position.x, mouseDownPositionX]);
  const bottomRightCornerY = useMemo(() => {
    return Math.max(position.y, mouseDownPositionY);
  }, [position.y, mouseDownPositionY]);

  useEffect(() => {
    dispatch(
      setCurrentDrawingRectangle([
        convertXToPdfUnits(
          topLeftCornerX +
            pageRef.current.parentElement.scrollLeft -
            canvas.canvasMarginLeft
        ),
        convertYToPdfUnits(
          topLeftCornerY + pageRef.current.parentElement.scrollTop
        ),
        convertXToPdfUnits(bottomRightCornerX - topLeftCornerX),
        convertYToPdfUnits(bottomRightCornerY - topLeftCornerY),
      ])
    );
  }, [topLeftCornerX, topLeftCornerY, bottomRightCornerX, bottomRightCornerY]);

  return (
    <>
      {(!isMouseDown ||
      !(pageRef && pageRef.current)) ? null : (
        <div
          className={classes.Rectangle}
          style={{
            left:
              topLeftCornerX + pageRef.current.parentElement.scrollLeft + "px",
            top:
              topLeftCornerY + pageRef.current.parentElement.scrollTop + "px",
            width: bottomRightCornerX - topLeftCornerX + "px",
            height: bottomRightCornerY - topLeftCornerY + "px",
            borderColor: settingColors.drawingObject
          }}
        ></div>
      )}
    </>
  );
};

export default DrawingItem;
